import React, { useState } from 'react';
import { useAppState } from '../RetailerFitGuide_StateContext.jsx';
import { track_fitTip } from '../Script/RetailerFitGuide_Tracking.js';
const RetailerFitGuide_FitTips = ({ journey, solution, initExpand }) => {
    if (!solution?.fitTips?.length > 0) return null;
    const {
        translations,
    } = useAppState();

    const [expandFitTips, setExpandFitTips] = useState(initExpand ? true : false);

    const onClickFitTip = () => {
        if (!expandFitTips)
            track_fitTip(journey);
        setExpandFitTips(!expandFitTips)
    }
    return (
        <div className={`retailerFitGuide_fitTips ${expandFitTips ? "retailerFitGuide_fitTips--expand" : ""}`}>
            <button onClick={onClickFitTip}><h2 className="heading4 mb-0 text-color--pitchBlack">{translations.fitTips}</h2><i className={`le-icon-${expandFitTips ? "minus" : "plus"}`}></i></button>
            {expandFitTips && <ul>
                {solution.fitTips.map((fitTip, index) => <li key={index} className="paragraph">{fitTip}</li>)}
            </ul>}
        </div>
    );
};

export default RetailerFitGuide_FitTips;